import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CADKernelService } from './services/cad-kernel.service';
import { SnapEngineService } from './services/snap-engine.service';
import { SketchService } from './services/sketch.service';
import { CADToolbarComponent } from './components/cad-toolbar/cad-toolbar.component';
import { SketchBrowserComponent } from './components/sketch-browser/sketch-browser.component';

/**
 * CAD Editor Module
 * 
 * Standalone module providing browser-based CAD functionality using OpenCascade.js.
 * Can be imported into any component that needs CAD editing capabilities.
 * 
 * Usage:
 * ```typescript
 * import { CADEditorModule } from '@app/features/cad-editor';
 * 
 * @Component({
 *   imports: [CADEditorModule],
 *   // ...
 * })
 * export class MyComponent { }
 * ```
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CADToolbarComponent,
    SketchBrowserComponent
  ],
  exports: [
    CADToolbarComponent,
    SketchBrowserComponent
  ],
  providers: [
    CADKernelService,
    SnapEngineService,
    SketchService
  ]
})
export class CADEditorModule { }

